import { __read, __spreadArray } from "tslib";
import { isFunction } from '@antv/util';
import { getCallbackValue } from '../../../util';
export function getCallbackStyle(style, params) {
    return Object.fromEntries(Object.entries(style).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return [key, getCallbackValue(val, params)];
    }));
}
export function baseDependencies(cfg) {
    if (cfg.type === 'linear')
        return __spreadArray(__spreadArray([], __read(cfg.startPos), false), __read(cfg.endPos), false);
    return __spreadArray(__spreadArray(__spreadArray([], __read(cfg.angleRange), false), __read(cfg.center), false), [cfg.radius], false);
}
export function filterExec(data, filter) {
    return !!filter && isFunction(filter) ? data.filter(filter) : data;
}
//# sourceMappingURL=utils.js.map